<template>
  <table class="product-specs">
    <tbody class="product-specs__body">
      <tr class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Country') }}
        </td>
        <td>{{ getTranslatedProperty({ ...product.country }) || $t('Unknown') }}</td>
      </tr>

      <tr class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Quality class') }}
        </td>
        <td><ProductCategory :id="product.category.id" /></td>
      </tr>

      <tr v-if="product.brand" class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Trademark') }}
        </td>
        <td>{{ product.brand.name }}</td>
      </tr>

      <tr class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Dimension') }}
        </td>
        <td>{{ product.caliber }}</td>
      </tr>

      <tr class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Kind of packing') }}
        </td>
        <td>{{ getTranslatedProperty(product.packing) }}</td>
      </tr>

      <tr class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Packing capacity (kg/liter)') }}
        </td>
        <td>{{ product.quantum }}</td>
      </tr>

      <tr v-if="product.wt_unit.id === unitPcs.id" class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Weight of one {0}', [$t(`units.weight.${product.wt_unit.name}`)]) }}.
        </td>
        <td>{{ product.one_item_weight }} {{ $t('units.weight.kg') }}</td>
      </tr>

      <tr v-else-if="product.wt_unit.id === unitPkg.id" class="product-specs__row">
        <td class="product-specs__table-label">
          {{ $t('Weight of one {0}', [$t(`units.weight.${product.wt_unit.name}`)]) }}.
        </td>
        <td>{{ product.one_item_weight }} {{ $t('units.weight.kg') }}</td>
      </tr>

      <template v-if="product.wt_unit.id === unitPkg.id && product.items_in_package > 1">
        <tr class="product-specs__row">
          <td class="product-specs__table-label">{{ $t('Amount in pack') }}.</td>
          <td>{{ product.items_in_package }} {{ $t('units.weight.pcs') }}</td>
        </tr>

        <tr class="product-specs__row">
          <td class="product-specs__table-label">{{ $t('Weight of a piece in a package') }}.</td>
          <td>{{ product.one_item_weight / product.items_in_package }} {{ $t('units.weight.kg') }}</td>
        </tr>
      </template>

      <tr v-if="product.tax" class="product-specs__row">
        <td class="product-specs__table-label">{{ $t('VAT') }}</td>
        <td>{{ $t('Included {0}%', [product.tax]) }}</td>
      </tr>

      <tr class="product-specs__row product-specs__extra-info">
        <td class="product-specs__table-label">
          {{ $t('Description') }}
        </td>

        <td v-if="product.extra_info" itemprop="description">
          {{ product.extra_info }}
        </td>

        <td v-else itemprop="description">
          {{ product.product.name }} {{ product.sort.name }} – {{ product.country.name }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { getTranslatedProperty } from '@/helpers/getTranslatedProperty'
import { mapGetters } from 'vuex'
import ProductCategory from '@/components/common/ProductCategory.vue'

export default {
  name: 'ProductPageSpecs',
  components: {
    ProductCategory,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('misc', ['unitPcs', 'unitPkg']),
  },
  methods: { getTranslatedProperty },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.product-specs {
  font-size: 13px;
  line-height: 1.2;

  @include media-breakpoint-up(xl) {
    font-size: 14px;
    line-height: 16px;
  }

  &__body {
    display: grid;
    gap: 6px;

    @include media-breakpoint-up(xl) {
      gap: 8px;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 100px 1fr;
    gap: 18px;
    align-items: center;

    @include media-breakpoint-up(xl) {
      gap: 28px;
      grid-template-columns: 105px 1fr;
    }
  }

  &__extra-info {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 4px;

    @include media-breakpoint-up(xl) {
      gap: 14px;
    }

    td:first-child {
      min-width: 100px;
      margin-right: 14px;

      @include media-breakpoint-up(xl) {
        min-width: 105px;
        margin-right: 14px;
      }
    }
  }

  &__table-label {
    color: $DGray;
  }
}
</style>
